// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ChecklistIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 19 18">
    <path
      fill="currentColor"
      d="M17.08 1.3a.36.36 0 0 1 .36.36v14.68a.36.36 0 0 1-.36.36H2.4a.36.36 0 0 1-.4-.36V1.66a.36.36 0 0 1 .4-.36zm0-1.3H2.4A1.66 1.66 0 0 0 .74 1.66v14.68A1.66 1.66 0 0 0 2.4 18h14.68a1.66 1.66 0 0 0 1.66-1.66V1.66A1.66 1.66 0 0 0 17.08 0"
    />
    <path
      fill="currentColor"
      d="M15.09 5.02H11.2a.15.15 0 0 0-.15.15v1q.02.14.15.15h3.89q.14-.01.15-.15v-1a.15.15 0 0 0-.15-.15M15.09 11.32H11.2a.15.15 0 0 0-.15.15v1q.02.13.15.15h3.89q.14-.02.15-.15v-1a.15.15 0 0 0-.15-.15M7.51 12l1-1a.67.67 0 0 0-.88-1l-1 1-1-1a.64.64 0 0 0-.92 0 .66.66 0 0 0 0 .92l1 1-1 1a.65.65 0 1 0 .92.92l1-1.05 1 1.05a.66.66 0 0 0 1.06-.21.6.6 0 0 0-.14-.71zM9.19 3.71a.64.64 0 0 0-.92 0L5.72 6.26l-.81-.81a.65.65 0 0 0-.91.92l1.27 1.27q.2.18.46.19a.7.7 0 0 0 .46-.19l3-3a.66.66 0 0 0 0-.93"
    />
  </svg>,
  "Checklist",
);
export default ChecklistIcon;
